import { CustomerMeal } from './CustomerMeal'
import { DinneyObject } from './DinneyObject'

export class Meal implements DinneyObject {

    mealid? : number
    details : string
    amount : number
    active : boolean
    position : number
    preventMinutes : number
    singlePayment : boolean
    editableForParent : boolean
    customerMeals? : CustomerMeal[]

    constructor(details : string, amount : number, active : boolean, position : number,
                singlePayment : boolean, editableForParent : boolean, preventMinutes : number,
                customerMeals? : CustomerMeal[], mealid? : number) {
        this.amount = amount
        this.details = details
        this.active = active
        this.customerMeals = customerMeals
        this.mealid = mealid
        this.position = position
        this.singlePayment = singlePayment
        this.preventMinutes = preventMinutes
        this.editableForParent = editableForParent
    }

}